import * as React from 'react';

import './styles.scss';
import {Row, Column} from '../../layout';
import * as fonts from '../../../util/fonts';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import {strings} from '../../../util/strings';
import {deepStringObjectMerger} from '../../../util/utility';
import {AuthConsumer} from '../../../providers/AuthProvider';
import {
  setIsLanguageSelected,
  setLanguage,
  setGlobalStyles,
  setWizard,
} from '../../../store/actions';
import AuthorizedImage from '../../images';
import {ITenant} from '../../../App';
import colors from '../../../util/colors';
interface RegisterHeaderProps {
  labels: typeof strings.pt.register;
  messagesLabels: typeof strings.pt.messages;
  user: any;
  languageOptions: any;
  setWizard(values: any): void;
  setIsLanguageSelected(values: any): void;
  setLanguage(values: any): void;
  setGlobalStyles(values: any): void;
  isDismiss?: any;
  backHome?: boolean;
  globalStyles: any;
  tenant: ITenant;
  language: any;
  defaultLabels: any;
  onLogoLoaded?: () => void;
}

function RegisterHeader({
  user,
  labels: labelsFromRedux,
  messagesLabels: messagesLabelsFromRedux,
  languageOptions,
  setWizard,
  setIsLanguageSelected,
  setLanguage,
  setGlobalStyles,
  isDismiss,
  backHome,
  globalStyles,
  tenant,
  language,
  defaultLabels,
  onLogoLoaded,
}: RegisterHeaderProps) {
  const labels = deepStringObjectMerger(strings.pt.register, labelsFromRedux);
  const messagesLabels = deepStringObjectMerger(
    strings.pt.messages,
    messagesLabelsFromRedux,
  );
  const [exitLabel, setExitLabel] = React.useState(
    labels?.register_headerExitLabel,
  );
  const history = useHistory();

  // obtains the "buid" search param in the url in order to customize the shown logo. -- not implemented
  const urlSearchParams = new URLSearchParams(window.location.search);
  var paramBuId = urlSearchParams.get('BuId');
  if (!paramBuId) paramBuId = localStorage.getItem('BuId');
  // condição se está logado ou não

  React.useEffect(() => {
    if (language === defaultLabels?.language) {
      setExitLabel(labels?.register_headerExitLabel);
    }
  }, [labels, language, defaultLabels?.language]);

  if (paramBuId === 'SBS') localStorage.setItem('BuId', 'SBS');
  return (
    <AuthConsumer>
      {({logout}) => (
        <Row className="bg-warning">
          <div className="register-header-container">
            <Row className="register-header-content">
              <Column className="register-header-content-logo-column-responsive">
                <AuthorizedImage
                  requiresAuthorization={false}
                  source={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${tenant?.footerImage}`}
                  alt="ADVLogo"
                  width="163"
                  height="55"
                  default={`${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${tenant?.footerImage}`}
                  onLoaded={onLogoLoaded}
                />
              </Column>
              <Column className="register-header-title-responsive"></Column>
              <Column className="register-header-content-exit-column">
                <Row
                  className="register-header-content-exit-label-row"
                  key={exitLabel?.length}>
                  <span
                    onClick={() => {
                      setWizard({});
                      setIsLanguageSelected(false);
                      setLanguage(
                        languageOptions?.find(
                          (option: any) =>
                            option.indexOf(
                              navigator.language?.split('-' || '_')[0],
                            ) > -1,
                        ) || messagesLabels?.default_language,
                      );
                      if (
                        !isDismiss &&
                        !(
                          user &&
                          Object.keys(user).length === 0 &&
                          user.constructor === Object
                        )
                      ) {
                        logout();
                      } else if (backHome) {
                        history.push('/inicio');
                      } else {
                        history.push('/');
                      }
                    }}
                    className="register-header-content-exit-label"
                    style={{
                      ...fonts.SM,
                      color: globalStyles?.primaryColor || colors.blue,
                      cursor: 'pointer',
                    }}>
                    {exitLabel}
                    <Icon
                      className="register-header-content-close-icon svg-close-button inline-svg-close-button"
                      name={Icons.CLOSE}
                      changeViewbox={true}
                      width={'12'}
                      height={'12'}
                      strokeWidth={'0.5'}
                    />
                  </span>
                </Row>
              </Column>
            </Row>
            <div className="custom-shape-divider-top-1605100206">
              <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path
                  d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                  className="shape-fill"></path>
              </svg>
            </div>
          </div>
        </Row>
      )}
    </AuthConsumer>
  );
}

const mapStateToProps = ({
  stringsDefault,
  user,
  languageOptions,
  globalStyles,
  tenant,
  language,
}: any) => ({
  labels: stringsDefault.value.pt.register ?? {},
  messagesLabels: stringsDefault.value.pt.messages ?? {},
  defaultLabels: stringsDefault.value,
  user: user.value,
  languageOptions: languageOptions.value,
  globalStyles: globalStyles.value,
  tenant: tenant.value,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterHeader);
